import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HeroSection() {
  const featuredMovie = hotMovies[0];

  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxury%20cinema%20hall%20with%20red%20velvet%20curtains%20and%20golden%20decor%2C%20dramatic%20stage%20lighting%2C%20movie%20projector%20beam%20cutting%20through%20darkness%2C%20elegant%20theater%20interior%2C%20warm%20golden%20accents%2C%20cinematic%20atmosphere%2C%20rich%20textures%2C%20majestic%20composition&width=1920&height=1080&seq=hero-bg-cinema&orientation=landscape"
          alt="天堂影院 - 高清在线影院"
          className="w-full h-full object-cover object-top"
          title="天堂影院 - 高清不缓冲 流畅在线观看"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              {/* Tag */}
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-50 text-xs font-medium mb-4">
                热门推荐
              </span>

              {/* Title */}
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-50 mb-4 leading-tight">
                天堂影院
              </h1>

              {/* Subtitle */}
              <p className="text-sm md:text-base text-foreground-300 mb-2 leading-relaxed">
                高清不缓冲 · 流畅在线观看 · 无广告影视
              </p>
              <p className="text-sm md:text-base text-foreground-400 mb-8 leading-relaxed">
                极速播放 · 蓝光画质 · 免费在线看大片
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to={`/article/1`}
                  className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-play-circle-fill"></i>
                  </div>
                  开始观影
                </Link>
                <Link
                  to="/category/all"
                  className="inline-flex items-center justify-center gap-2 bg-background-100/80 hover:bg-background-200/80 text-foreground-200 px-6 py-3 rounded-md text-sm font-medium transition-all duration-200 border border-background-300/40 cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-grid-line"></i>
                  </div>
                  浏览电影大全
                </Link>
              </div>

              {/* Stats */}
              <div className="flex flex-wrap items-center gap-6 mt-10">
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold font-heading text-primary-500">1000+</p>
                  <p className="text-xs text-foreground-600">高清影片</p>
                </div>
                <div className="w-px h-8 bg-background-300/40"></div>
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold font-heading text-primary-500">4K</p>
                  <p className="text-xs text-foreground-600">蓝光画质</p>
                </div>
                <div className="w-px h-8 bg-background-300/40"></div>
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold font-heading text-accent-500">0</p>
                  <p className="text-xs text-foreground-600">广告打扰</p>
                </div>
                <div className="w-px h-8 bg-background-300/40"></div>
                <div className="text-center">
                  <p className="text-xl md:text-2xl font-bold font-heading text-accent-500">24/7</p>
                  <p className="text-xs text-foreground-600">畅享观影</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}